import { Feature, Map } from "ol";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import { transform } from "ol/proj";
import { Cluster } from "ol/source";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { VesselMapItem } from "../types/mapItems";
import { findLayerByTitle } from "./findLayerByTitle";

export const addAISVesselsToMap = (
  map: Map,
  aisVessels: VesselMapItem[],
  layer: LayerTitle = LayerTitle.Vessels,
): void => {
  const layerFeatures = aisVessels.map((v) => {
    const f = new Feature({
      geometry: new Point(
        transform([v.longitude, v.latitude], "EPSG:4326", "EPSG:3857"),
      ),
      name: v.name,
    });
    // Set properties etc
    f.setProperties({ ...v });
    f.setId(`vessel${v.mmsi}`);
    return f;
  });
  const vesselLayer = findLayerByTitle(map, layer) as VectorLayer;
  const cluster = vesselLayer.getSource() as Cluster;
  const source = cluster.getSource();
  if (!source) return;
  source.clear();
  source.addFeatures([...layerFeatures]);
  cluster.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
};
